import api from "./api";

export async function listAgenda() {
  const { data } = await api.get("/Agenda");
  return data;
}

export async function getAgendaMes(ano, mes) {
  const { data } = await api.get(`/Agenda/mes/${ano}/${mes}`);
  return data;
}

export async function createAgenda(payload) {
  const { data } = await api.post("/Agenda", payload);
  return data;
}

export async function updateAgenda(id, payload) {
  await api.put(`/Agenda/${id}`, payload);
}

export async function deleteAgenda(id) {
  await api.delete(`/Agenda/${id}`);
}

// Alterna um dia entre Livre ↔ Bloqueado. Dias Vendidos (vinculados a
// roteiros) retornam 409 Conflict — o frontend exibe uma mensagem.
// `motivo` é opcional e aplicado só quando o dia passa para Bloqueado.
export async function toggleBloqueio(data, motivo) {
  const res = await api.post("/Agenda/toggle-bloqueio", { data, motivo });
  return res.data;
}

// Bloqueia um intervalo [inicio, fim] inclusive com o mesmo motivo.
// Dias Vendidos no intervalo são preservados e reportados em `diasVendidos`.
export async function bloquearRange(inicio, fim, motivo) {
  const res = await api.post("/Agenda/bloquear-range", { inicio, fim, motivo });
  return res.data;
}
